import { Link } from "react-router-dom";
import { Card, CardContent } from "../../components/ui/card";
import { Badge } from "../../components/ui/badge";
import { getCopy } from "../../brand";
import { Mic, Target, Award, TrendingUp, TrendingDown } from "lucide-react";
import BRAND from "../../brand";

export function StatsGrid({ analytics }) {
  const getReadinessColor = (classification) => {
    switch (classification) {
      case "field-ready": return "text-[#14B8A6] bg-[#14B8A6]/10";
      case "needs-coaching": return "text-[#F59E0B] bg-[#F59E0B]/10";
      default: return "text-red-500 bg-red-50";
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      <Card className="premium-card fade-up fade-up-delay-1" data-testid="readiness-card">
        <CardContent className="p-6">
          <div className="flex items-start justify-between mb-4">
            <div className="w-12 h-12 bg-[#2563EB]/10 rounded-xl flex items-center justify-center">
              <Target className="w-6 h-6 text-[#2563EB]" />
            </div>
            <Badge className={getReadinessColor(analytics?.readiness_classification)}>
              {getCopy.classificationMessage(analytics?.readiness_classification)}
            </Badge>
          </div>
          <div className="text-4xl font-bold text-[#0B1F3B] mb-1">
            {analytics?.average_readiness || 0}%
          </div>
          <p className="text-sm text-slate-500">{BRAND.terms.readinessScore}</p>
        </CardContent>
      </Card>

      <Card className="premium-card fade-up fade-up-delay-2" data-testid="sessions-card">
        <CardContent className="p-6">
          <div className="flex items-start justify-between mb-4">
            <div className="w-12 h-12 bg-[#14B8A6]/10 rounded-xl flex items-center justify-center">
              <Mic className="w-6 h-6 text-[#14B8A6]" />
            </div>
          </div>
          <div className="text-4xl font-bold text-[#0B1F3B] mb-1">
            {analytics?.total_sessions || 0}
          </div>
          <p className="text-sm text-slate-500">{BRAND.terms.sessions}</p>
        </CardContent>
      </Card>

      <Card className="premium-card fade-up fade-up-delay-3" data-testid="score-card">
        <CardContent className="p-6">
          <div className="flex items-start justify-between mb-4">
            <div className="w-12 h-12 bg-[#F59E0B]/10 rounded-xl flex items-center justify-center">
              <Award className="w-6 h-6 text-[#F59E0B]" />
            </div>
          </div>
          <div className="text-4xl font-bold text-[#0B1F3B] mb-1">
            {analytics?.average_score || 0}
          </div>
          <p className="text-sm text-slate-500">Average Score</p>
        </CardContent>
      </Card>

      <Card className="premium-card fade-up fade-up-delay-4" data-testid="improvement-card">
        <CardContent className="p-6">
          <div className="flex items-start justify-between mb-4">
            <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${
              (analytics?.improvement || 0) >= 0 ? 'bg-[#14B8A6]/10' : 'bg-red-50'
            }`}>
              {(analytics?.improvement || 0) >= 0 ? (
                <TrendingUp className="w-6 h-6 text-[#14B8A6]" />
              ) : (
                <TrendingDown className="w-6 h-6 text-red-500" />
              )}
            </div>
          </div>
          <div className={`text-4xl font-bold mb-1 ${
            (analytics?.improvement || 0) >= 0 ? 'text-[#14B8A6]' : 'text-red-500'
          }`}>
            {(analytics?.improvement || 0) >= 0 ? '+' : ''}{analytics?.improvement || 0}%
          </div>
          <p className="text-sm text-slate-500">Improvement</p>
        </CardContent>
      </Card>
    </div>
  );
}
